import styled from 'styled-components';

const FormWrapper = styled.form`
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  max-width: 930px;
  padding: 30px 50px;
  margin-bottom: 100px;
  background: #ffffff;
  border-radius: 15px;
  .event-form-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
  .event-form-actions button {
    min-width: 0;
    max-width: 100%;
    height: auto;
    min-height: 44px;
    white-space: normal;
    line-height: 1.5;
  }
  @media (max-width: 640px) {
    padding: 24px 16px;
    .event-form-actions { flex-direction: column; align-items: stretch; }
  }
`;

const InputGroupWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: center;
  > div { min-width: 0; }

  > div input[type='date'] {
    width: 150px;
  }
  @media (max-width: 640px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
    text-align: left;
    .MuiFormControl-root { width: 100%; min-width: 0; max-width: 100%; }
    > div input[type='date'] { width: 100%; box-sizing: border-box; }
  }
`;
const CopyIconWarpper = styled.span`
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: pointer;
`;

export { FormWrapper, InputGroupWrapper, CopyIconWarpper };
